module.exports = window.SkeduloPlatform.ReactDOM